import {Flex} from 'antd';
import {ReactElement, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';
import {ReviewLogTimelineEntryType} from '../../../../../../../../service/reviews/reviews-logs';
import {LogActionsEnum} from '../../../../../review-logs/review-log-type';

import {HistoryCatalogEditSection} from './history-catalog-edit-section';
import {HistoryExpandableText} from './history-expandable-text';

type ReviewLogValueType = Extract<ReviewLogTimelineEntryType, {source: 'log'}>['newValue'];

type PropsType = {
    action: string;
    formattedDate: string | null;
    formattedTime: string | null;
    newValue: ReviewLogValueType;
    oldValue: ReviewLogValueType;
    userName: string;
};

export function NoteLog(props: PropsType): ReactElement {
    const {formattedDate, formattedTime, action, newValue, oldValue, userName} = props;

    const noteLocaleString = useMemo((): LangKeyType => {
        if (action === LogActionsEnum.Created) {
            return 'REVIEWS__REVIEW_NOTE_CREATED_BY';
        }

        if (action === LogActionsEnum.Deleted) {
            return 'REVIEWS__REVIEW_NOTE_DELETED_BY';
        }

        return 'REVIEWS__REVIEW_NOTE_UPDATED_BY';
    }, [action]);

    const isUpdated = action === LogActionsEnum.Updated;

    return (
        <Flex gap={4} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Text block lighter stringKey={noteLocaleString} valueMap={{user: <Text bolder>{userName}</Text>}} />
            {isUpdated ? (
                <Flex gap={16} vertical>
                    <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__BEFORE">
                        <HistoryExpandableText value={oldValue as ReviewHistoryDataType['oldValue']} />
                    </HistoryCatalogEditSection>
                    <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__AFTER">
                        <HistoryExpandableText value={newValue as ReviewHistoryDataType['oldValue']} />
                    </HistoryCatalogEditSection>
                </Flex>
            ) : (
                <HistoryExpandableText
                    value={
                        (action === LogActionsEnum.Created ? newValue : oldValue) as ReviewHistoryDataType['oldValue']
                    }
                />
            )}
        </Flex>
    );
}
